var exports = {
  "n": "xaf9ae18d--e0be3b--link",
};

module.exports = exports;
